// extracted by mini-css-extract-plugin
export default {"close-button":"styles_close-button__02rjz","closeButton":"styles_close-button__02rjz"};